"use strict";
exports.__esModule = true;
var _1 = require("./");
// eslint-disable-next-line @typescript-eslint/no-use-before-define
exports.ok = function (value) { return new Ok(value); };
// eslint-disable-next-line @typescript-eslint/no-use-before-define
exports.err = function (err) { return new Err(err); };
var Ok = /** @class */ (function () {
    function Ok(value) {
        var _this = this;
        this.value = value;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.match = function (ok, _err) {
            return ok(_this.value);
        };
    }
    Ok.prototype.isOk = function () {
        return true;
    };
    Ok.prototype.isErr = function () {
        return !this.isOk();
    };
    Ok.prototype.map = function (f) {
        return exports.ok(f(this.value));
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Ok.prototype.mapErr = function (_f) {
        return exports.ok(this.value);
    };
    Ok.prototype.andThen = function (f) {
        return f(this.value);
    };
    Ok.prototype.asyncMap = function (f) {
        return _1.ResultAsync.fromPromise(f(this.value));
    };
    Ok.prototype._unsafeUnwrap = function () {
        return this.value;
    };
    Ok.prototype._unsafeUnwrapErr = function () {
        throw new Error('Called `_unsafeUnwrapErr` on an Ok');
    };
    return Ok;
}());
exports.Ok = Ok;
var Err = /** @class */ (function () {
    function Err(error) {
        var _this = this;
        this.error = error;
        this.match = function (_ok, err) {
            return err(_this.error);
        };
    }
    Err.prototype.isOk = function () {
        return false;
    };
    Err.prototype.isErr = function () {
        return !this.isOk();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Err.prototype.map = function (_f) {
        return exports.err(this.error);
    };
    Err.prototype.mapErr = function (f) {
        return exports.err(f(this.error));
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Err.prototype.andThen = function (_f) {
        return exports.err(this.error);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Err.prototype.asyncMap = function (_f) {
        return _1.errAsync(this.error);
    };
    Err.prototype._unsafeUnwrap = function () {
        throw new Error('Called `_unsafeUnwrap` on an Err');
    };
    Err.prototype._unsafeUnwrapErr = function () {
        return this.error;
    };
    return Err;
}());
exports.Err = Err;
